import IocTabGroup from './ioc-tab-group'

export default {
  install: function (Vue) {
    Vue.component(IocTabGroup.name, IocTabGroup)
  }
}
